// extracted by mini-css-extract-plugin
export var lightMode = "_s-0";